/// <amd-module name="Feed/Legacy/Helpers/FeedNameResolver" />
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";
import { Feed as CustomFeed } from "Feed/Common/Contracts/Feed";

export function getFullyQualifiedFeedName(feed: Feed, viewName: string = null): string {
    if (feed == null) {
        return null;
    }

    if (viewName != null) {
        return feed.name + "@" + viewName;
    }

    if (feed.view != null && feed.view.name != null) {
        return feed.name + "@" + feed.view.name;
    }

    return feed.name;
}

export function getFullyQualifiedFeedId(feed: Feed | CustomFeed): string {
    if (feed == null) {
        return null;
    }

    if (feed.view != null) {
        return feed.id + "@" + feed.view.id;
    }

    return feed.id;
}
